import { getStandardButtonStyles } from "../../styles/standardButtons";
import React, { useState, useEffect, useRef } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { Stack } from "@mui/material";
import Switch from "@material-ui/core/Switch";

const useStyles = makeStyles(theme => ({
  ...getStandardButtonStyles(theme),
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  btnWrapper: {
    position: "relative"
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Digite um nome!"),
  text: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Digite uma mensagem!")
});

const FlowBuilderAddTextModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);



  const [textDig, setTextDig] = useState();
  const [nodeName, setNodeName] = useState("");
  const [antiBan, setAntiBan] = useState(false);

  useEffect(() => {
    if (open === "edit") {

      setTextDig(data.data.label);
      setNodeName(data.data.name || "");
      setAntiBan(!!data.data.antiBan);
      setActiveModal(true);
    } else if (open === "create") {

      setTextDig("");
      setNodeName("");
      setAntiBan(false);
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null)
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { ...data.data, label: textDig, name: nodeName, antiBan }
      });
      return;
    } else if (open === "create") {
      handleClose();
      onSave({
        text: textDig,
        name: nodeName,
        antiBan
      });
    }
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {open === "edit" ? (i18n.t("flowBuilder.text.editTitle") || "Editar mensagem ao fluxo") : (i18n.t("flowBuilder.text.addTitle") || "Adicionar mensagem ao fluxo")}
        </DialogTitle>
        <Stack>
          <DialogContent dividers>
            <TextField
              label={i18n.t("flowBuilder.input.internalName") || "Nome Interno"}
              variant="outlined"
              value={nodeName}
              onChange={e => setNodeName(e.target.value)}
              margin="dense"
              fullWidth
              className={classes.textField}
              style={{ width: "95%", marginBottom: "15px" }}
              helperText={i18n.t("flowBuilder.input.internalNameHelper") || "Nome para identificar este nó no editor"}
            />
            <TextField
              label={i18n.t("flowBuilder.text.fields.message") || "Mensagem"}
              multiline
              rows={7}
              name="text"
              variant="outlined"
              value={textDig}
              margin="dense"
              onChange={e => setTextDig(e.target.value)}
              className={classes.textField}
              style={{ width: "95%" }}
            />

            <div style={{ marginTop: "16px", marginBottom: "8px", background: antiBan ? "rgba(74,222,128,0.07)" : "rgba(128,128,128,0.1)", border: `1px solid ${antiBan ? "#4ade80" : "rgba(128,128,128,0.2)"}`, borderRadius: "8px", padding: "10px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "all 0.3s ease", width: "95%" }}>
              <div>
                <Typography variant="subtitle2" style={{ fontWeight: 700, color: antiBan ? "#4ade80" : "inherit" }}>
                  🛡️ AntiBan IA {antiBan ? "[Activado]" : "[Desactivado]"}
                </Typography>
                <Typography variant="caption" style={{ color: "gray", display: "block" }}>
                  {antiBan ? "Re-escribe el texto usando IA para variar los envíos y evitar bloqueos. (Consume saldo IA)" : "Envía el texto exactamente como se configuró sin usar saldo de IA."}
                </Typography>
              </div>
              <Switch checked={antiBan} onChange={(e) => setAntiBan(e.target.checked)} color="primary" />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className={classes.secondaryButton}>{i18n.t("common.cancel") || "Cancelar"}</Button>
            <Button type="submit" onClick={() => handleSaveContact()} className={classes.applyButton}>
              {open === "edit" ? (i18n.t("common.save") || "Salvar") : (i18n.t("common.add") || "Adicionar")}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddTextModal;
